import { ChangeDetectionStrategy, Component, output } from '@angular/core';

import { ButtonModule, IconModule } from '@hglobal/common';

@Component({
  selector: 'pt-accept-decline-buttons',
  templateUrl: './accept-decline-buttons.component.html',
  styleUrls: ['./accept-decline-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconModule, ButtonModule, IconModule, ButtonModule],
})
export class AcceptDeclineButtonsComponent {
  acceptEmitter = output<void>();
  declineEmitter = output<void>();
}
